import { gql, useQuery } from "utils/urql";
import { HomepageOffledeQuery } from "types/api";
import Image from "components/Image";
import HomepageMetadata from "./HomepageMetadata";
import Caption from "./Caption";
import styles from "./Offlede.module.scss";

const query = gql`
  query HomepageOfflede {
    homepageModule(slug: "offlede", version: "b1") {
      ... on HomepagePromoItemList {
        items {
          id
          url
          title
          wideImage: riverImage(
            width: 296
            height: 167
            sizes: [
              "291w"
              "296w"
              "455w"
              "543w"
              "582w"
              "592w"
              "910w"
              "1086w"
            ]
          ) {
            url
            width
            height
            srcSet
            altText
            attributionText
            attributionUrl
          }
          authors {
            id
            url
            displayName
          }
        }
      }
    }
  }
`;

const Title = ({
  title,
  url,
  riverIndex,
}: {
  title: string;
  url: string;
  riverIndex: number;
}) => (
  <h1 className={styles.title}>
    <a
      className={styles.titleLink}
      dangerouslySetInnerHTML={{ __html: title }}
      data-action={`click link - offlede - title ${riverIndex}`}
      href={url}
    ></a>
  </h1>
);

const Offlede = () => {
  const [{ data }] = useQuery<HomepageOffledeQuery>({ query });

  if (!data || data.homepageModule?.__typename !== "HomepagePromoItemList")
    return null;

  const articles = data.homepageModule?.items;
  return (
    <ul className={styles.list}>
      {articles.map(({ authors, id, title, url, wideImage }, idx) => (
        <li className={styles.listItem} key={id}>
          <article className={styles.article}>
            {wideImage && (
              <figure className={styles.figure}>
                <a
                  href={url}
                  data-action={`click link - offlede - image ${idx + 1}`}
                >
                  <Image
                    lazy={false}
                    className={styles.image}
                    src={wideImage.url}
                    srcSet={wideImage.srcSet}
                    alt={wideImage.altText}
                    width={wideImage.width}
                    height={wideImage.height}
                    sizes="(min-width: 1296px) 296px, (min-width: 976px) calc(25vw - 32px), (min-width: 576px) calc(50vw - 32px), calc(100vw - 32px)"
                  />
                </a>
                <Caption
                  attributionText={wideImage.attributionText}
                  attributionUrl={wideImage.attributionUrl}
                />
              </figure>
            )}

            <div className={styles.info}>
              <Title title={title} url={url} riverIndex={idx + 1} />
              <HomepageMetadata
                authors={authors}
                analyticsSection="offlede"
                riverIndex={idx + 1}
              />
            </div>
          </article>
        </li>
      ))}
    </ul>
  );
};

export default Offlede;
